import _ from 'lodash';
import React from 'react';

import ArtistStatusFilter from './artist-status-filter';
import ArtistTierFilter from './artist-tier-filter';


class ArtistsFilterBar extends React.Component {
	render () {
		return (
			<div className="grid-x align-middle margin-bottom-1">
				<div className="cell auto">
					<ArtistStatusFilter />
				</div>

				<div className="cell auto">
					<ArtistTierFilter />
				</div>
			</div>
		);
	}
}

export default ArtistsFilterBar;
